import {
  AudioRecordingModelData,
  AudioRecordingRecordingStatus,
} from "@/store/audio-recordings/types";
import { BaseAudioRecordingAppEventOperation } from "./BaseAudioRecordingAppEventOperation";
import { AudioRecordingAppEventOperationKind } from "@/store/sync/operations/types";

export class MarkStartedLocalAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind(): AudioRecordingAppEventOperationKind {
    return "MARK_STARTED_LOCAL_AUDIO_RECORDING";
  }

  protected getModelDataUpdates(
    existingData: AudioRecordingModelData
  ): Partial<AudioRecordingModelData> {
    // Don't transition back from COMPLETED state
    if (existingData.recording_status === AudioRecordingRecordingStatus.COMPLETED) {
      return {};
    }
    return {
      recording_status: AudioRecordingRecordingStatus.IN_PROGRESS,
    };
  }
}
